import { Component, OnInit } from '@angular/core';
import { ModalService, StateService } from 'projects/shared/src/public-api';

@Component({
  selector: 'app-absence-overview',
  templateUrl: './absence-overview.component.html',
  styleUrls: ['./absence-overview.component.scss'],
  standalone: false,
})
export class AbsenceOverviewComponent implements OnInit {
  constructor(public state: StateService, public modalService: ModalService) {}

  ngOnInit() {}
  public selectedUser: string;

  handleRefresh(event: any) {
    this.state.loadAbsenceEntries().subscribe((x) => {
      event.target.complete();
    });
  }

  public async openAbsenceFormModal() {
    await this.modalService.openAbsenceFormModal(null, this.selectedUser);
  }
}
